'use client';

const CarouselDots = ({
  count,
  selectedIndex,
  onSelect,
  label,
  slideOf,
}: CarouselDotsProps) => {
  if (count <= 1) return null;

  return (
    <ul aria-label={label} className="mt-10 flex">
      {Array.from({ length: count }).map((_, i) => {
        const active = i === selectedIndex;
        return (
          <li key={i}>
            <button
              type="button"
              aria-label={`${i + 1} ${slideOf} ${count}`}
              aria-current={active || undefined}
              onClick={() => onSelect(i)}
              className="size-12 flex items-center justify-center"
            >
              <span
                className={[
                  'block h-3 w-3 desktop:h-4 desktop:w-4 rounded-full transition-opacity duration-200 cursor-pointer',
                  active
                    ? 'opacity-100 bg-secondary'
                    : 'opacity-40 bg-secondary',
                ].join(' ')}
              />
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default CarouselDots;

type CarouselDotsProps = {
  count: number;
  selectedIndex: number;
  onSelect: (index: number) => void;
  label: string;
  slideOf: string;
};
